/**
 * Hostname-aware site shell.
 * Detects whether the app is being served on the school domain and exposes
 * a single source of truth for the rest of the app to consult.
 */

const SCHOOL_DOMAINS = ['scholarathlete.academy', 'www.scholarathlete.academy'];

// Forced school-only build per SCHOOL_SPLIT_MANIFEST §1.
// This project only ever renders the Academy — regardless of hostname.
export const isSchoolHost = () => true;

export const SITE = {
  isSchool: isSchoolHost(),
  brand: isSchoolHost() ? 'Scholar Athlete Academy' : 'PRSVR',
  title: isSchoolHost()
    ? 'Scholar Athlete Academy | The Sovereign K-12 Path'
    : 'PRSVR | Elevated Lifestyle',
  description: isSchoolHost()
    ? 'An Elite Academy for Scholar Athletes. California State Standards aligned. Fully compliant with California private-school regulations. Biometric verified. Built for the field.'
    : 'PRSVR - Elevated Lifestyle Brand. Premium fashion, custom team uniforms, and luxury streetwear. Built on perseverance since 2012.',
};

/**
 * Apply site-level meta when the app boots (and on hostname change in dev).
 * Updates: <title>, <meta name="description">, theme-color, plus a body
 * data attribute so CSS can target school-mode if we ever need to.
 */
export const applySiteShell = () => {
  if (typeof document === 'undefined') return;
  document.title = SITE.title;
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name="${name}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute('name', name);
      document.head.appendChild(tag);
    }
    tag.setAttribute('content', content);
  };
  setMeta('description', SITE.description);
  if (SITE.isSchool) {
    setMeta('theme-color', '#000000');
    document.body?.setAttribute('data-site', 'school');
  } else {
    document.body?.setAttribute('data-site', 'prsvr');
  }
};
